export { ContextLostError, SceneCompositor } from './webgl/scene-compositor';
export type {
  CompositorEvent,
  CompositorOptions,
  ExportImageOptions,
  SceneSource,
  ViewRect,
} from './webgl/scene-compositor';
export { largestSceneTier, neededSceneWidth, pickSceneTier, type TierLimits } from './tiers';
export { DoorCompositor, type DoorState } from './webgl/door-compositor';
export {
  bindingUniforms,
  doorFinishBinding,
  hexToLinear,
  kitchenMaterialBinding,
  pickTextureTier,
  type MaterialBinding,
} from './materials';
export { computeDoorLayer, type DoorLayerParams } from './door-layer';
export { acesFilm, linearToSrgb, srgbToLinear } from './cpu/tonemap';

/** True when the browser can run the compositor (WebGL2 + createImageBitmap options). */
export function isCompositorSupported(): boolean {
  if (typeof document === 'undefined' || typeof createImageBitmap === 'undefined') return false;
  try {
    const canvas = document.createElement('canvas');
    return !!canvas.getContext('webgl2');
  } catch {
    return false;
  }
}
